import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import WidgetTypeCardUpdated from '../WidgetTypeCard.custom_section_discover';
import WidgetTypeCard, { Props as ImportedProps } from './WidgetTypeCard';
import WidgetTypeCardContainer from './WidgetTypeCard.container';

export default withFeatureBranch({
  custom_section_discover: WidgetTypeCardUpdated,
})(WidgetTypeCardContainer(WidgetTypeCard));

export type Props = ImportedProps;
